export default class DiagnosticLinkMaterialDto {
    constructor(obj) {
        this.codeDiagnostic = obj.codeDiagnostic
        this.materialType = obj.materialType
    }
}
